import { render } from "./ActionSms.vue?vue&type=template&id=1f09c4ea"
import script from "./ActionSms.vue?vue&type=script&lang=js"
export * from "./ActionSms.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__